import React, { ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import InputText from '@/components/UI/InputText/InputText';
import { formatValue, getTotalReworkTime } from './feedback-utils';
import { CampaignOfFeedbackSubCR } from '@/types';
import { FEEDBACK } from '@/helpers/constants';

type ExternalReworkTimesProps = {
  index: number;
  campaign: CampaignOfFeedbackSubCR;
  getLabelForPossibleDisabledInput: (label: string, field: string) => ReactNode;
  checkIsDisabledField: (field: string) => boolean;
  handleChangeIntegerField: (label: string, value: string, section: string, isSyncField: boolean, index: number, isCalculated?: boolean) => void;
};

const ExternalReworkTimes = (props: ExternalReworkTimesProps) => {
  const { t } = useTranslation();
  const { index, campaign, getLabelForPossibleDisabledInput, checkIsDisabledField, handleChangeIntegerField } = props;
  const { inspection, rework, diagnosis, rollerTest, total } = campaign.externalReworkTimes || {};

  useEffect(() => {
    handleChangeIntegerField(FEEDBACK.TOTAL, `${getTotalReworkTime([inspection, rework, diagnosis, rollerTest])}`, FEEDBACK.EXT_REWORK, false, index, true);
  }, [inspection, rework, diagnosis, rollerTest]);

  const fieldConfig = [
    { fieldName: FEEDBACK.TOTAL, idSuffix: FEEDBACK.TOTAL, label: 'feedback.externalTotalTime', value: total, alwaysDisabled: true },
    { fieldName: FEEDBACK.INSPECTION, idSuffix: 'check', label: 'feedback.checkTime', value: inspection },
    { fieldName: FEEDBACK.REWORK, idSuffix: FEEDBACK.REWORK, label: 'feedback.reworkTime', value: rework },
    { fieldName: FEEDBACK.DIAGNOSIS, idSuffix: FEEDBACK.DIAGNOSIS, label: 'feedback.diagnosisTime', value: diagnosis },
    { fieldName: FEEDBACK.ROLLER_TEST, idSuffix: 'roller', label: 'feedback.rollerTime', value: rollerTest },
  ];

  return (
    <>
      <h3>{t('feedback.externalReworkTimes')}</h3>
      <Grid container spacing={2} rowSpacing={2} sx={{ marginBottom: '16px' }} columnSpacing={1}>
        {fieldConfig.map(({ fieldName, idSuffix, label, value, alwaysDisabled }) => (
          <Grid item xs={12} sm={6} md={3} key={fieldName}>
            <InputText
              id={`input-campaign-external-${idSuffix}-time-feedback-${index}`}
              fieldPath={[FEEDBACK.FEEDBACK, `campaigns[${index}]`, FEEDBACK.EXT_REWORK, fieldName]}
              noTranslationField
              label={getLabelForPossibleDisabledInput(label, `externalReworkTimes.${fieldName}`)}
              type="number"
              {...(!alwaysDisabled && {
                handleChange: (ev) => handleChangeIntegerField(fieldName, ev.target.value, FEEDBACK.EXT_REWORK, false, index),
                placeholder: `${t('feedback.message')} (min: 1, max: 9999)`,
              })}
              value={formatValue(value)}
              className='w-100'
              disabled={alwaysDisabled || checkIsDisabledField(`externalReworkTimes.${fieldName}`)}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default ExternalReworkTimes;
